import {
  setAuthorizationHeader,
  addResponseError401Interceptor,
} from '@/api/auth';
import AUTH from '@/constants/auth';

const accessToken = localStorage.getItem(AUTH.STORAGE_ACCESS_TOKEN);
if (accessToken) {
  setAuthorizationHeader(accessToken);
  addResponseError401Interceptor();
}
